var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdministrative(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 5.3125V7H10.8125V5.3125C10.8125 3.76562 9.54688 2.5 8 2.5C6.41797 2.5 5.1875 3.76562 5.1875 5.3125ZM2.9375 7V5.3125C2.9375 2.53516 5.1875 0.25 8 0.25C10.7773 0.25 13.0625 2.53516 13.0625 5.3125V7H13.625C14.8555 7 15.875 8.01953 15.875 9.25V16C15.875 17.2656 14.8555 18.25 13.625 18.25H2.375C1.10938 18.25 0.125 17.2656 0.125 16V9.25C0.125 8.01953 1.10938 7 2.375 7H2.9375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministrative);
export default __webpack_public_path__ + "static/media/administrative.396f7e33718a188d5326356468c3c296.svg";
export { ForwardRef as ReactComponent };